export default function InsightBox({ children, className = "" }) {
  return <div className={`insight-box ${className}`}>{children}</div>;
}
